/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import {
  apiClient,
  handleResponse,
} from './axios';

async function getFile(data) {
  try {
    const res = await apiClient.post('/getfile', data);
    return res;
  } catch (error) {
    return error;
  }
}

async function deleteFile(data) {
  try {
    const res = await apiClient.post('/googlestorage/delete/', data);
    return res;
  } catch (error) {
    return error;
  }
}

const fileServices = {
  getFile,
  deleteFile,
};

export default fileServices;
